<template>
  <div>
    <v-row dense>
      <v-col cols="10" style="margin-top: 10px; margin-bottom: 20px;">
        <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
        <h3 class="b-indicator__collapse-subtitle">Исходные данные:</h3>
        <p>
          <span class="font-weight-bold mb-1">Форма 5.07. (фрагмент)</span><br>
          Численность обучающихся по программам бакалавриата, программам специалитета, программам магистратуры
          <br>
          по данным формы ВПО-1, человек
        </p>
      </v-col>
    </v-row>
    <div style="display: flex; flex-direction: row">
      <wrapper-preview-category
          style="max-width: 1250px; background: unset; box-shadow: unset"
      >
        <grid-table
            :headers="rowOfValues.data.isnps23 == 0 ? headers.table_1 : headers.table_3"
            :headers-for-rows="rowOfValues.data.isnps23 == 0 ? headersForRows1 : headersForRows3"
            :num-cols="18"
            :gap="'0'"
            :data-rows="rowOfValues.data.isnps23 == 0 ? table1 : table3"
            type-table="grid"
        ></grid-table>
      </wrapper-preview-category>
      <div style="display: flex; flex-direction: column; justify-content: space-between; margin: 200px 0 80px 25px;">
        <img style="width: 76px" :src="require('@/assets/images/Vector_rigth_arrow.svg')" alt=""/>
      </div>
      <wrapper-preview-category
          style="max-width: 350px; margin-left: 30px; margin-top: 50px; background: unset; box-shadow: unset; align-self: end;">
        <grid-table
            :headers="headers.table_2"
            :headers-for-rows="headersForRows2"
            :num-cols="3"
            :gap="'0'"
            :data-rows="table2"
            type-table="grid"
        >
          <template #no20="{row}">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no20, 0, 'integer') }}
          </template>
          <template #no21="{row}">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no21, 0, 'integer') }}
          </template>
          <template #no22="{row}">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(row.no22, 0, 'integer') }}
          </template>
        </grid-table>
      </wrapper-preview-category>
    </div>

    <h3 class="b-indicator__collapse-subtitle mt-5">Расчет приведенных контингентов:</h3>
    <div class="d-flex flex-row align-center">
      <formuls-fraction-simple :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">
            <span class="formul-text">BP</span> = 1,0 ×
            <span class="formul-text">BPo</span> + 0,25 ×
            <span class="formul-text">BPv</span> +  0,1 ×
            <span class="formul-text">BPz</span> = 1,0 ×
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkbco22, 0, 'integer') }}
            </span>
            + 0,25 ×
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkbcv22, 0, 'integer') }}
            </span>
            +  0,1 ×
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkbcz22, 0, 'integer') }}
            </span>
            =
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkbcp22, 0, 'integer') }}
            </span>
          </span>
        </template>
      </formuls-fraction-simple>
    </div>


    <div class="d-flex flex-row align-center">
      <formuls-fraction-simple :need-bottom-line="false">
        <template>
          <span class="alternate-text">
            <span class="formul-text">CP</span> = 1,0 ×
            <span class="formul-text">CPo</span> + 0,25 ×
            <span class="formul-text">CPv</span> +  0,1 ×
            <span class="formul-text">CPz</span> = 1,0 ×
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkspo22, 0, 'integer') }}
            </span>
            + 0,25 ×
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkspv22, 0, 'integer') }}
            </span>
            +  0,1 ×
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkspz22, 0, 'integer') }}
            </span>
            =
            <span class="formul-text">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkspp22, 0, 'integer') }}
            </span>
          </span>
        </template>
      </formuls-fraction-simple>
    </div>

    <div class="d-flex flex-row align-center">
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"><span class="formul-text">NMP</span> =</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="true">
        <template>
          <span class="alternate-text">
            1,0 × <span class="formul-text">NMo</span>
          </span>
        </template>
        <template #bottom>очная<br> форма</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> +</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="true">
        <template>
          <span class="alternate-text">
            0,25 × <span class="formul-text">NMv</span>
          </span>
        </template>
        <template #bottom>очно-заочная<br> форма</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> +</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="true">
        <template>
          <span class="alternate-text">
            0,1 × <span class="formul-text">NMz</span>
          </span>
        </template>
        <template #bottom>заочная<br> форма</template>
      </formulsFraction>


      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">=</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="true">
        <template>
          <span class="alternate-text">
            1,0 × <span class="formul-text">{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkmgo22, 0, 'integer')
            }}</span>
          </span>
        </template>
        <template #bottom>очная<br> форма</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> +</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="true">
        <template>
          <span class="alternate-text">
            0,25 × <span class="formul-text">{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkmgv22, 0, 'integer')
            }}</span>
          </span>
        </template>
        <template #bottom>очно-заочная<br> форма</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> +</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="true">
        <template>
          <span class="alternate-text">
            0,1 × <span class="formul-text">{{
              $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkmgz22, 0, 'integer')
            }}</span>
          </span>
        </template>
        <template #bottom>заочная<br> форма</template>
      </formulsFraction>

      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">=</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="true">
        <template>
          <span class="alternate-text">
            <span class="formul-text">{{
                $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkmgp22, 0, 'integer')
              }}</span>
          </span>
        </template>
        <template #bottom>приведенный<br> контингент</template>
      </formulsFraction>
    </div>

    <p>BP - приведенный контингент студентов бакалавриата </p>
    <p>CP - приведенный контингент студентов специалитета</p>
    <p>NMP - приведенный контингент студентов магистратуры</p>

    <h3 class="b-indicator__collapse-subtitle mt-5">Расчет значения показателя:</h3>
    <div class="d-flex flex-row align-center">
      <formulsFraction :need-bottom-line="true">
        <template>
          <div class="d-flex flex-row align-end">
            {{ item.title }}
            <div class="little-text ">0</div>
          </div>
        </template>
        <template #bottom>значение<br> показателя</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">=</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          BP + CP
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            NMP
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">=</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkbcp22, 0, 'integer') }} +
          {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkspp22, 0, 'integer') }}
        </template>
        <template #bottom>
          <div class="formul-text" style="min-height: 49px">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nkmgp22, 0, 'integer') }}
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-7 alternate-text">{{ rowOfValues.data[valueForBsm7] }}</span>
        </template>
      </formulsFraction>
    </div>
    <p style="max-width: unset; margin-bottom: 25px;">
      Если сумма значений показателей BP и CP больше нуля, а значение показателя NMP равно нулю (либо отсутствует),
      значение показателя принимается равным 1.
    </p>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import config from "@/components/cards/indicatiors/cardsTables/config/m25";
import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple";

export default {
  name: "m25",
  components: {GridTable, WrapperPreviewCategory, formulsFraction, formulsFractionSimple},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
  },
  data() {
    return {
      headers: config,
      table1: [],
      table2: [],
      table3: []
    }
  },
  computed: {
    headersForRows1() {
      return this.headers.table_1.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    headersForRows2() {
      return this.headers.table_2.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    headersForRows3() {
      return this.headers.table_3.reduce((acc, el) => {
        if (el.variable) {
          acc.push({...el, rows: 1});
        }
        return acc;
      }, [])
    },
    // valueForBsm1() {
    //   if (this.item.idUsl === 1) {
    //     return this.rowOfValues.data.nnbcs_20
    //   } else if (this.item.idUsl === 2) {
    //     return this.rowOfValues.data.nnsps20
    //   } else if (this.item.idUsl === 3) {
    //     return this.rowOfValues.data.nnmgs_20
    //   } else {
    //     return ''
    //   }
    // },
    // valueForBsm2() {
    //   if (this.item.idUsl === 1) {
    //     return this.rowOfValues.data.nobcs20
    //   } else if (this.item.idUsl === 2) {
    //     return this.rowOfValues.data.nosps20
    //   } else if (this.item.idUsl === 3) {
    //     return this.rowOfValues.data.nomgs20
    //   } else {
    //     return ''
    //   }
    // },
    valueForBsm7() {
      return String(this.item.dataFieldName) + 'b022'
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.table1 = [
        {
          bsm: `${this.rowOfValues.data.ugorg.slice(0, 2)}.00.00 ${this.rowOfValues.data.ugtxt}`,
          isUgtxt: true,
          xxx: '',
          nb20: '',
          nb21: '',
          nb22: '',
          nq20: '',
          nq21: '',
          nq22: '',
        },
        {
          bsm: 'Бакалавриат',
          xxx: '...',
          nb20: this.rowOfValues.data.tabB22usl1[0]?.nosgo22,
          nb21: this.rowOfValues.data.tabB22usl1[0]?.nosgv22,
          nb22: this.rowOfValues.data.tabB22usl1[0]?.nosgz22,
          nq20: this.rowOfValues.data.tabB22usl1[0]?.noqgo22,
          nq21: this.rowOfValues.data.tabB22usl1[0]?.noqgv22,
          nq22: this.rowOfValues.data.tabB22usl1[0]?.noqgz22,
        },
        {
          bsm: 'Специалитет',
          xxx: '...',
          nb20: this.rowOfValues.data.tabB22usl2[0]?.nosgo22,
          nb21: this.rowOfValues.data.tabB22usl2[0]?.nosgv22,
          nb22: this.rowOfValues.data.tabB22usl2[0]?.nosgz22,
          nq20: this.rowOfValues.data.tabB22usl2[0]?.noqgo22,
          nq21: this.rowOfValues.data.tabB22usl2[0]?.noqgv22,
          nq22: this.rowOfValues.data.tabB22usl2[0]?.noqgz22,
        },
        {
          bsm: 'Магистратура',
          xxx: '...',
          nb20: this.rowOfValues.data.tabB22usl3[0]?.nosgo22,
          nb21: this.rowOfValues.data.tabB22usl3[0]?.nosgv22,
          nb22: this.rowOfValues.data.tabB22usl3[0]?.nosgz22,
          nq20: this.rowOfValues.data.tabB22usl3[0]?.noqgo22,
          nq21: this.rowOfValues.data.tabB22usl3[0]?.noqgv22,
          nq22: this.rowOfValues.data.tabB22usl3[0]?.noqgz22,
        },
      ];

      this.table2 = [
        {
          no20: this.rowOfValues.data.nkbco22,
          no21: this.rowOfValues.data.nkbcv22,
          no22: this.rowOfValues.data.nkbcz22,
        },
        {
          no20: this.rowOfValues.data.nkspo22,
          no21: this.rowOfValues.data.nkspv22,
          no22: this.rowOfValues.data.nkspz22,
        },
        // {
        //   no20: ``,
        //   no21: ``,
        //   no22: ``,
        // },
        {
          no20: this.rowOfValues.data.nkmgo22,
          no21: this.rowOfValues.data.nkmgv22,
          no22: this.rowOfValues.data.nkmgz22,
        },
      ];

      //////////////////////////// isNPS.22 ===  1

      if (this.rowOfValues.data.isnps23 == 1) {
        const b = this.rowOfValues.data.tabB22usl1.filter(el => el.kcpGroup.usl.id === 1);
        const s = this.rowOfValues.data.tabB22usl2.filter(el => el.kcpGroup.usl.id === 2);
        const m = this.rowOfValues.data.tabB22usl3.filter(el => el.kcpGroup.usl.id === 3);


        if (b.length > 0 || s.length > 0 || m.length > 0) {
          this.table3.push({
            bsm: `${this.rowOfValues.data.ug}.00.00`,
            isUgtxt: true,
            xxx: '',
            nb20: '',
            nb21: '',
            nb22: '',
            nq20: '',
            nq21: '',
            nq22: '',
          })
        }

        if (b.length > 0) {
          this.table3.push({
            bsm: `Бакалавриат`,
            isUgtxt: true,
            xxx: '',
            nb20: '',
            nb21: '',
            nb22: '',
            nq20: '',
            nq21: '',
            nq22: '',
          })

          b.map(el => {
            return this.table3.push({
              ...el,
              bsm: `${el.ugorg.slice(0, 2)}.00.00 ${el.ugtxt}`,
              xxx: '...',
              nb20: this.rowOfValues.data.tabB22usl1[0]?.nosgo22,
              nb21: this.rowOfValues.data.tabB22usl1[0]?.nosgv22,
              nb22: this.rowOfValues.data.tabB22usl1[0]?.nosgz22,
              nq20: this.rowOfValues.data.tabB22usl1[0]?.noqgo22,
              nq21: this.rowOfValues.data.tabB22usl1[0]?.noqgv22,
              nq22: this.rowOfValues.data.tabB22usl1[0]?.noqgz22,
            })
          })
        }

        if (s.length > 0) {
          this.table3.push({
            bsm: `Специалитет`,
            isUgtxt: true,
            xxx: '',
            nb20: '',
            nb21: '',
            nb22: '',
            nq20: '',
            nq21: '',
            nq22: '',
          })

          s.map(el => {
            return this.table3.push({
              ...el,
              bsm: `${el.ugorg.slice(0, 2)}.00.00 ${el.ugtxt}`,
              xxx: '...',
              nb20: this.rowOfValues.data.tabB22usl2[0]?.nosgo22,
              nb21: this.rowOfValues.data.tabB22usl2[0]?.nosgv22,
              nb22: this.rowOfValues.data.tabB22usl2[0]?.nosgz22,
              nq20: this.rowOfValues.data.tabB22usl2[0]?.noqgo22,
              nq21: this.rowOfValues.data.tabB22usl2[0]?.noqgv22,
              nq22: this.rowOfValues.data.tabB22usl2[0]?.noqgz22,
            })
          })

          // for (let j = 0; j < s.length; j++) {
          //   this.table2.splice(b.length, 0,{
          //     no20: ``,
          //     no21: ``,
          //     no22: ``,
          //   })
          // }
        }

        if (m.length > 0) {
          this.table3.push({
            bsm: `Магистратура`,
            isUgtxt: true,
            xxx: '',
            nb20: '',
            nb21: '',
            nb22: '',
            nq20: '',
            nq21: '',
            nq22: '',
          })

          m.map(el => {
            return this.table3.push({
              ...el,
              bsm: `${el.ugorg.slice(0, 2)}.00.00 ${el.ugtxt}`,
              xxx: '...',
              nb20: this.rowOfValues.data.tabB22usl3[0]?.nosgo22,
              nb21: this.rowOfValues.data.tabB22usl3[0]?.nosgv22,
              nb22: this.rowOfValues.data.tabB22usl3[0]?.nosgz22,
              nq20: this.rowOfValues.data.tabB22usl3[0]?.noqgo22,
              nq21: this.rowOfValues.data.tabB22usl3[0]?.noqgv22,
              nq22: this.rowOfValues.data.tabB22usl3[0]?.noqgz22,
            })
          })
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>

</style>